const union = (arr1, arr2, comparer = (x, y) => x === y) => {
    const result = [...arr1];

    for (let i = 0; i < arr2.length; i++) {
        const y = arr2[i];
        if (result.length > 0) {
            if (!result.some(x => comparer(x, y))) {
                result.push(y);
            }
        } else {
            result.push(y);
        }
    }

    return result;
}

export {
    union
}